import { render, staticRenderFns } from "./LogisticDashboard.vue?vue&type=template&id=378abe47&scoped=true"
import script from "./LogisticDashboard.vue?vue&type=script&lang=js"
export * from "./LogisticDashboard.vue?vue&type=script&lang=js"
import style0 from "./LogisticDashboard.vue?vue&type=style&index=0&id=378abe47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378abe47",
  null
  
)

export default component.exports